/**
 * TreatmentVisual.js
 * 
 * Displays the visual for the Treatment section.
 * Extracted from legacy MainRight.js logic using IlAdd active="tr".
 * Ensures correct markup and class names for CSS compatibility.
 */

export const TreatmentVisual = ({ tr, lower }) => {
  // Based on MainRight.js: IlAdd active="tr", tr={props.treatment[0]}
  // The 'tr' prop (e.g., "HyperDry", "ExpeDRY") influences the visual.

  const getVisualSrc = (treatmentType, lowerContext) => {
    let baseDir = "/img/hyperdry/";
    let prefix = "aside";
    let suffix = "-tr.jpg";

    if (treatmentType === "ExpeDRY") {
      baseDir = "/img/expedry/";
      prefix = "treatment-expedry";
      suffix = ".jpg"; // <-- ADD THIS
    } else if (treatmentType === "UltraWht") {
      baseDir = "/img/ultrawht/";
      prefix = "aside"; // aside-one.jpg, aside-two.jpg, aside-three.jpg
      suffix = ".jpg";
    } else if (treatmentType === "ThermaDown O2+") {
      baseDir = "/img/thermadown-o2-plus/";
      prefix = "aside"; // aside-one.jpg, aside-two.jpg, aside-three.jpg
      suffix = ".jpg";
    }

    if (lowerContext === "left") {
      return `${baseDir}${prefix}-two${suffix}`;
    } else if (lowerContext === "right") {
      return `${baseDir}${prefix}-three${suffix}`;
    } else {
      // Default or "upper" case
      return `${baseDir}${prefix}-one${suffix}`;
    }
  };

  const visualSrc = getVisualSrc(tr, lower);

  return (
    <div className="il-add tr" style={{ backgroundImage: `url(${visualSrc})` }}></div>
  );
};